import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {Alert} from "react-bootstrap";
import jwt from "jsonwebtoken";
import {userActions} from "../../../actions/user.actions";
import {connect} from "react-redux";

class UserProfilePage extends Component {

    state = {
        loading: null,
        detailsForm: {
            firstName: '',
            lastName: '',
            username: '',
            email: '',
            role: {
                id: null,
                label: null
            },
        },
        changePassword: {
            password: '',
            newPassword: '',
            newPasswordConfirm: ''
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        const token = localStorage.getItem('auth-token');
        const objectUser = jwt.decode(token);
        dispatch(userActions.getUserById(objectUser.Id));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.getById !== this.props.getById) {
            this.setState({
                ...this.state,
                detailsForm: this.props.getById
            });
        }
    }

    handleOnChangeInputUser = (e) => {
        this.setState({
            ...this.state,
            detailsForm: {
                ...this.state.detailsForm,
                [e.target.name]: e.target.value
            }
        })
    };

    handleOnChangeInputPassword = (e) => {
        this.setState({
            ...this.state,
            changePassword: {
                ...this.state.changePassword,
                [e.target.name]: e.target.value
            }
        })
    };

    handleOnSubmitDetails = (e) => {
        e.preventDefault();
        const { dispatch } = this.props;
        dispatch(userActions.editProfileDetails(this.state.detailsForm));
    };

    handleOnSubmitChangePassword = (e) => {
        e.preventDefault();
        const { dispatch } = this.props;
        dispatch(userActions.changePassword({
            userName: this.state.detailsForm.username,
            email: this.state.detailsForm.email,
            password: this.state.changePassword.password,
            newPassword: this.state.changePassword.newPassword,
            newPasswordConfirm: this.state.changePassword.newPasswordConfirm
        }));
    };

    validationNewPassword = () => {
        const { changePassword } = this.state;
        return !((changePassword.newPassword !== '' || changePassword.newPasswordConfirm !== '') && changePassword.newPasswordConfirm === changePassword.newPassword)
    }

    render() {
        const { t } = this.props;

        const breadcrumb = [
            { value: 'setting-profile', path: '#' }
        ];

        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{ t('setting-profile') }</h4>

                <div className="row">
                    <div className="col-md-12">
                        <Alert variant={"warning"}>
                            { t('alert-change-profile') }
                        </Alert>
                    </div>
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-header">
                                <h5>{t('details')}</h5>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.handleOnSubmitDetails}>
                                    <div className="form-group ">
                                        <label
                                            className="col-form-label"
                                        > {t('firstName')} </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="firstName"
                                            value={this.state.detailsForm?.firstName || ''}
                                            onChange={this.handleOnChangeInputUser}
                                            required
                                        />
                                    </div>

                                    <div className="form-group ">
                                        <label
                                            className="col-form-label"
                                        > {t('lastName')} </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="lastName"
                                            value={this.state.detailsForm?.lastName || ''}
                                            onChange={this.handleOnChangeInputUser}
                                            required
                                        />
                                    </div>

                                    <div className="form-group ">
                                        <label
                                            className="col-form-label"
                                        > {t('userName')} </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="username"
                                            value={this.state.detailsForm?.username || ''}
                                            onChange={this.handleOnChangeInputUser}
                                            required={this.state.detailsForm.email === ''}
                                        />
                                    </div>

                                    <div className="form-group ">
                                        <label
                                            className="col-form-label"
                                        > {t('email')} </label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            value={this.state.detailsForm?.email || ''}
                                            onChange={this.handleOnChangeInputUser}
                                            required={this.state.detailsForm.userName === ''}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label> {t('role')} </label>
                                        <input
                                            type="text"
                                            disabled
                                            className="form-control"
                                            name="role-name"
                                            readOnly
                                            value={this.state.detailsForm?.role.label || ''}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={!this.state.detailsForm}
                                        >
                                            <i className="fas fa-edit"> </i> {t('edit')}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    {/*CHANGE PASSWORD*/}
                    <div className="col-md-4">
                        <div className="card">
                            <div className="card-header">
                                <h5>{t('change-password')}</h5>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.handleOnSubmitChangePassword}>
                                    <div className="form-group">
                                        <label className="col-form-label"> {t('current-password')} </label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            name="password"
                                            value={this.state.changePassword?.password || '' }
                                            onChange={this.handleOnChangeInputPassword}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="col-form-label"> {t('new-password')} </label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            name="newPassword"
                                            value={this.state.changePassword?.newPassword || '' }
                                            onChange={this.handleOnChangeInputPassword}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="col-form-label"> {t('confirm-new-password')} </label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            name="newPasswordConfirm"
                                            value={this.state.changePassword?.newPasswordConfirm || '' }
                                            onChange={this.handleOnChangeInputPassword}
                                        />
                                    </div>
                                    <div className="form-group mt-4">
                                        <button type="submit" className="btn btn-info" disabled={this.validationNewPassword()}>
                                            <i className="fas fa-edit"> </i> {t('change-password')}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { getById } = state.userReducer;
    return {
        getById
    }
};

export default withNamespaces()(connect(mapStateToProps)(UserProfilePage));
